<br />
<div *ngIf="toggle">
  <div class="form-row">
    <table>
      <tr>
        <td>
      <h3 for="inventors">Ar-Ge Merkezi Kaydı</h3></td><td>
      <h4>Kayıtlı Ar-Ge Merkezleri</h4>
<h1 *ngIf="record"   style="background-color: #d70040">{{record}}</h1>
      <ng-container><tr *ngFor="let user of users; let i = index">

        <td *ngFor="let item of user | filter: searchText">{{i+1}}.{{item.centerName|json}} </td><td>  <button
          type="button"

          class="btn btn-primary"
          style="background-color: #d70040"
          (click)="removeRDCenter(i)"
        >
          Ar-Ge Merkezi kaydını sil
        </button></td></ng-container>
    </td>



         <td>
            <input [(ngModel)]="rdName" placeholder="Yeni Ar-Ge Merkezinin Adı"
            (ngModelChange)="rdName = $event.toLowerCase()"
            /></td>
            <td>
            <button
            [disabled]="!rdName"
  type="button"
  class="btn btn-warning"
  style="background-color: #d70040"
  (click)="recordRDCenter()"
>
 Ar-Ge Merkezini Kaydet
</button>
</td>
        </tr>
        </table>
        <br/>
        <table>
          <tr>
            <td>
          <h3 for="inventors">Yeni Proje Kaydı</h3></td>
          <td>
            <h5 style="margin-left: 5%">Proje Kodu</h5>
                <input [(ngModel)]="projectCode" placeholder="Projenin Kodu"
                (ngModelChange)="projectCode = $event.toLowerCase()"
                /></td>
                <td>
                  <h5 style="margin-left: 5%">Proje Açıklaması</h5>
                  <textarea type="text" rows="3" cols="42" [(ngModel)]="projectDetail" placeholder="Projenin Açıklaması"
                  (ngModelChange)="projectDetail = $event.toLowerCase()"
                  ></textarea></td>
                <td>
                <button
                [disabled]="!projectCode || !projectDetail"
      type="button"
      class="btn btn-warning"
      style="background-color: #d70040"
      (click)="recordProject()"
    >
     Projeyi Kaydet
    </button>
    </td>
            </tr>
            </table>








  </div>
</div>


<h2 *ngIf="error">
  {{ error }} . Lütfen kayıt bilgilerinizi ve internetinizi kontrol ediniz.
</h2>
<br />



<h2 style="margin-left: 2%" >
  Kayıtlı Projeler
</h2>

<h2 *ngIf="error">
  {{ error }} . Lütfen kayıt bilgilerinizi ve internetinizi kontrol ediniz.
</h2>
<input
  *ngIf="!error"
  class="form-control"
  type="text"
  name="search"
  class="icon"
  [(ngModel)]="searchText"
  (ngModelChange)="searchText = $event.toLowerCase()"
  autocomplete="off"
  placeholder="Proje Bilgileri Üzerinden Arama Yap"
  id="input1"
/>

<table *ngIf="!error">
  <thead>
    <th>#</th>
    <th>Proje Kodu</th>
    <th>Proje Açıklaması</th>

    <th>Kaydı oluşturan ve kayıt tarihi</th>
  </thead>
  <tbody>
    <tr *ngFor="let user of projectUsers; let i = index">
      <ng-container *ngFor="let item of user | filter: searchText">
        <td>{{ i + 1 }}</td>
        <td>{{ item.projectCode}}</td>
        <td>{{ item.projectDetail }}</td>


        <td>
          Kaydı Yapan:{{ item.LoggedUser[0].recordingUser }}
          <p>Kayıt Tarihi:{{ item.LoggedUser[0].date | date: "dd/MM/yyyy" }}</p>
        </td>
        <td style="background-color: #f8f9fb">
          <button
          type="button"

          class="btn btn-primary"
          style="background-color: #d70040"
          (click)="removeProject(i)"
        >
         Proje kaydını sil
        </button>
        </td>
      </ng-container>
    </tr>
  </tbody>
</table>
<h1 *ngIf="recordProjects"   style="background-color: #d70040">{{recordProjects}}</h1>
